window.businessSearcher = (
  openBlank,
  sourcePage,
  categoryId,
  categoryName,
  categoryNormalizedName,
  categoryTreeLevels,
  locationNormalizedName,
  businessAutocompleteUrl,
  serviceFullCloudUrl
) => {
  const isIframe = () => {
    return window.frameElement !== null;
  };

  const initCategorySearcher = $input => {
    var selectedCategoryId = categoryId;
    var selectedCategoryName = categoryName;

    $input.categorySearcher({
      tree_level: categoryTreeLevels,
      extraOption: {
        id: -1,
        name: __('Ver todas las categorías'),
        redirectUrl: serviceFullCloudUrl,
        target: '_self'
      },
    });

    if (selectedCategoryId) {
      $input.categorySearcher('val', selectedCategoryName);
      $input.categorySearcher('keyVal', selectedCategoryId);
    }
  };

  const initLocationSearcher = $input => {
    $input.LocationSearcher();
  };

  function getValuesFromInputs($input) {
    return $input
      .map(function () {
        return $(this).val();
      })
      .get()
      .filter(function (value) {
        return value;
      })
  }

  const getCorrectUrl = () => {
    var params = {};
    var categoryValues = getValuesFromInputs($('[data-typeahead-id="category-name"]'));
    var locationValues = getValuesFromInputs($('[data-typeahead-id="location-name"]'));
    var $searcher = isMobile() ? $locationSearcherMobile : $locationSearcherDesktop;
    var locationValuesInputVal = $searcher.val().trim();

    if (openBlank) {
      var windowReference = window.open();
    }

    if (categoryValues.length) {
      params['unified-category-id'] = categoryValues[0];
    }

    if (locationValues.length) {
      params['location-id'] = locationValues[0];
    } else if (locationValuesInputVal) {
      params['location-value'] = locationValuesInputVal;
    }

    if (sourcePage) {
      params['source_page'] = sourcePage;
    }

    $.ajax({
      url: businessAutocompleteUrl,
      type: 'GET',
      datatype: 'json',
      data: params,
      success: function (res) {
        trackCustomDimensions();
        if (res.url !== "" && res.url !== null) {
          if (openBlank) {
            windowReference.location = res.url;
          } else {
            window.top.location.href = res.url;
          }
        }
      }
    });
  };

  const trackCustomDimensions = () => {
    if (typeof dataLayer != "undefined" && filters.category && filters.location) {
      dataLayer.push({
        'searched_category': filters.category.normalized_name,
        'searched_location': filters.location.normalized_name === undefined ?
          filters.location :
          filters.location.normalized_name,
      });
    }
  };

  const trackBlurLocationInput = evt => {
    var locationValues = getValuesFromInputs($('[data-typeahead-id="location-name"]'));
    if (locationValues.length) return;

    filters.location = evt.target.value;
    updateTrackEvent();
  };

  const updateTrackEvent = () => {
    var trackEvent = 'Directory.MainCTASearch.';
    if (filters.category) {
      trackEvent += filters.category.normalized_name;
    }

    if (filters.location && filters.location.normalized_name) {
      trackEvent += '_' + filters.location.normalized_name;
    }

    if (filters.location && !filters.location.normalized_name) {
      trackEvent += '_' + filters.location;
    }

    $dataFindEvents.each(function (index, element) {
      $(element).attr('data-trackevent', trackEvent);
    });
  };

  const isNotEmpty = $input => {
    return $input.val().trim() !== '';
  };

  const $categorySearcherDesktop = $('#category-name');
  const $categorySearcherMobile = $('#interactive-category-name');
  const $locationSearcherDesktop = $('#location-name');
  const $locationSearcherMobile = $('#interactive-location-name');
  const $mobileModal = $('#mobile-modal');
  const $dataFindEvents = $('[data-find]');

  let filters = {};
  let selectedCategoryNormalizedName = categoryNormalizedName;
  let selectedLocationNormalizedName = locationNormalizedName;

  // Need it because typeahead not suggest first item already initialized
  $('.business-searcher-request').attr('data-trackevent', 'Directory.MainCTASearch');

  if (selectedCategoryNormalizedName) {
    filters.category = {
      'normalized_name': selectedCategoryNormalizedName,
    }
  }

  if (selectedLocationNormalizedName) {
    filters.location = {
      'normalized_name': selectedLocationNormalizedName,
    }
  }

  if (selectedCategoryNormalizedName || selectedLocationNormalizedName) {
    updateTrackEvent();
  }

  if (isMobile()) {
    initCategorySearcher($categorySearcherMobile);
    initLocationSearcher($locationSearcherMobile);
  }

  $mobileModal.on("mobileSearcher_DoSearch", function () {
    getCorrectUrl();
  });

  initCategorySearcher($categorySearcherDesktop);
  initLocationSearcher($locationSearcherDesktop);

  $mobileModal.on('businessSearcherModalClosed', function () {
    initCategorySearcher($categorySearcherDesktop);
    initLocationSearcher($locationSearcherDesktop);
  });

  $categorySearcherDesktop.on('typeahead:selected typeahead:autocompleted', function (evt, category) {
    filters.category = category;
    updateTrackEvent();

    if (!isNotEmpty($locationSearcherDesktop)) {
      $locationSearcherDesktop.focus();
    }
  });

  $categorySearcherDesktop.on('click', function (evt) {
    if (isMobile()) {
      $categorySearcherDesktop.typeahead('destroy');
    }
  });

  $locationSearcherDesktop.on('click', function (evt) {
    if (isMobile()) {
      $locationSearcherDesktop.typeahead('destroy');
    }
  });

  $locationSearcherDesktop.on('typeahead:selected typeahead:autocompleted', function (evt, location) {
    filters.location = location;
    updateTrackEvent();

    if (!isNotEmpty($categorySearcherDesktop)) {
      $categorySearcherDesktop.focus();
    }
  });

  $categorySearcherMobile.on('typeahead:selected typeahead:autocompleted', function (evt, category) {
    filters.category = category;
    updateTrackEvent();
  });

  $locationSearcherMobile.on('typeahead:selected typeahead:autocompleted', function (evt, location) {
    filters.location = location;
    updateTrackEvent();
  });

  $locationSearcherDesktop.on('blur', function (evt) {
    trackBlurLocationInput(evt);
  });

  $locationSearcherMobile.on('blur', function (evt) {
    trackBlurLocationInput(evt);
  });

  $locationSearcherDesktop.on('keyup', function (evt) {
    var enter_code = 13;
    if (evt.keyCode === enter_code) {
      $dataFindEvents.focus().click();
    }
  });

  $dataFindEvents.on('click', function (evt) {
    evt.preventDefault();
    if (!isMobile() && !isIframe()) {
      $(this).addClass('btn-spinner disabled');

      var isValidCategorySearcher = isNotEmpty($categorySearcherDesktop);
      var isValidLocationSearcher = isNotEmpty($locationSearcherDesktop);
      var isValid = isValidCategorySearcher && isValidLocationSearcher;
      if (isValid) {
        getCorrectUrl();
      } else {
        $(this).removeClass('btn-spinner disabled');

        if (!isValidCategorySearcher) {
          $categorySearcherDesktop.focus();
        } else {
          $locationSearcherDesktop.focus();
        }
      }
    } else {
      getCorrectUrl();
    }
  });
};
